/** @module TS.UI */
/** @name TS.UI */
TS.UI = TS.UI || {};

(function () {

    var _maskTask = null,
        maskElementName = 'load-mask',
        maskQueryName = '#' + maskElementName,

        popupWindowCounter = 1;

    function getWindowElement() {
        var elementId = 'popupWindow-container' + popupWindowCounter++,
            element = $('#' + elementId)[0];

        if (!element) {
            // create a div as a placeholder for window
            element = $('<div id="' + elementId + '"></div>');
        }
        return element;
    }

    /** exports */
    $.extend(TS.UI, {
        Mask: {
            //see http://fgnass.github.io/spin.js for options explanation
            config: {
                lines: 12,
                length: 20,
                width: 5,
                radius: 15,
                trail: 60,
                speed: 1.0
            },

            /**
             * <p>Covers the user interface with a transparent mask and a progress indicator, preventing the user from interacting with UI elements.</p>
             * <p>The UI is covered immediately.</p>
             * @static
             */
            show: function (delay) {

                if (delay === true) {
                    if (_maskTask) {
                        return;
                    }
                    _maskTask && _maskTask.cancel();
                    _maskTask = new TS.util.DelayedTask(function () {
                        TS.UI.Mask.show();
                    });
                    _maskTask.delay(TS.Constants.ShowIndicatorDelay);
                    return;
                }

                var $document = $(document),
                    maskHeight = $document.height(),
                    maskWidth = $document.width(),
                    $loadMask = $(maskQueryName);

                $loadMask.css({'width': maskWidth, 'height': maskHeight});
                $loadMask.show();
                $loadMask.spin(TS.UI.Mask.config);
                $loadMask.find('.spinner').css({'position': 'fixed', 'left': '50%', 'top': '50%'});
            },

            /**
             * <p>Removes the transparent mask from the user interface.</p>
             * @static
             */
            hide: function () {
                if (_maskTask) {
                    _maskTask.cancel();
                    _maskTask = false;
                }
                var $loadMask = $(maskQueryName);
                $loadMask.spin(false);
                $loadMask.hide();
            },

            isVisible: function () {
                return $(maskQueryName).is(":visible") || (_maskTask !== null && typeof _maskTask !== 'undefined');
            }
        },

        viewDomain: function (options, callback) {
            var view,
                viewContent,
                viewModel = options.viewModel || {},
                viewElement = getWindowElement(),
                viewOptions = {
                    appendTo: $('body'),

                    modal: true,
                    resizable: true,
                    draggable: true,
                    visible: false,

                    width: options.popupWidth || $(window).width() * 0.8,
                    height: options.popupHeight || $(window).height() * 0.8,

                    error: function (e) {
                        TS.Log.warn('Error showing model. ' + TS.Log.getXHRInfo(e.xhr));
                        TS.Notify.error('An error has occured. Please contact your administrator.');
                    },
                    close: function (e) {
                        var widget;
                        // intercept only user-triggered events (i.e.: clicked the upper-right 'X' button)
                        if (e.userTriggered) {
                            TS.trace('Before window close');
                            if (viewModel.canClose && (viewModel.canClose() === false)) {
                                e.preventDefault();
                                return;
                            }
                            if (viewModel.close) {
                                //do not destroy widget, see onModelClose handler for viewModel close event.
                                e.preventDefault();
                                viewModel.close(true, true);
                                return;
                            }

                            // destroy the window - cleans up the DOM
                            widget = $(popupEl).data("kendoWindow");
                            if (widget) {
                                widget.destroy();
                            }
                        }
                    }
                };

            TS.UI.Mask.show(true);

            function onLoad() {
                TS.UI.Mask.hide();
                if (!TS.UI.popupModel) {
                    return;
                }

                TS.UI.popupModel._merge(viewModel);
                viewModel = TS.UI.popupModel;

                view = view || $(viewElement).data('kendoWindow');
                elem = $(view.element);
                view.title(ko.valueOf(viewModel.Title));

                // the window title is a <span> element, so use the 'html' binding
                var header = $(parent).find('.k-window-title')[0];
                if (header) {
                    $(header).attr('data-bind', 'html: title');
                }

                //floatable navigator
                var floatableNavBar = elem.find('.nav-block-float');
                if (floatableNavBar.length) {
                    elem.find('#burgerMenu').show();
                    floatableNavBar.click(function () {
                        floatableNavBar.removeClass('show');
                    });
                }

                //top floating elements
                ts.topFloatingElement('.top-floating-element');
                TS.bind(viewModel, viewElement[0]);

                setTimeout(function () {
                    TS.scrollNav.initialize(elem)
                }, 0);

                viewModel.on('close', function (e) {
                    view.close();
                    view.destroy();
                });

                viewModel.on('closing', function (e) {
                    if (options.ignoreResponse) {
                        e.ignoreResponse = true;
                    }
                });

                TS.UI.models.push(viewModel);
                view.center().open();
                //hack, it seems that grids with fixed columns are rendered correctly
                view.resize(true);
                callback && callback(viewModel);
            };

            if (options.content) {
                viewContent = options.content;
                delete options.content;
            } else {
                viewOptions.content = {
                    url: options.url,
                    data: options.data,
                    refresh: onLoad
                };
            }

            options.proprocess && options.proprocess(viewOptions);
            view = $(viewElement).kendoWindow(viewOptions);
            view = view.data('kendoWindow');
            if (viewContent) {
                view.content(viewContent);
                onLoad();
            }

        }
    });
})();